import { cn } from '@/lib/utils';

interface EmojiSuggestion {
  id: string;
  native: string;
  name: string;
}

interface EmojiSuggestionsProps {
  suggestions: EmojiSuggestion[];
  onSelect: (emoji: EmojiSuggestion) => void;
  query: string;
}

/**
 * Inline dropdown showing emoji shortcode suggestions.
 * Renders as a compact list below the input — notebook paper style.
 */
export function EmojiSuggestions({ suggestions, onSelect, query }: EmojiSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div
      className="bg-white border border-cream-dark shadow-[0_4px_12px_rgba(45,27,78,0.12)] max-h-[200px] overflow-y-auto"
    >
      <div className="py-1">
        {suggestions.map((emoji) => (
          <button
            key={emoji.id}
            type="button"
            onMouseDown={(e) => {
              // Use mouseDown instead of click to fire before input blur
              e.preventDefault();
              onSelect(emoji);
            }}
            className={cn(
              'w-full flex items-center gap-2 px-3 py-1.5 text-left',
              'hover:bg-cream-dark/40 transition-colors',
            )}
          >
            <span className="text-lg leading-none">{emoji.native}</span>
            <span className="font-hand text-sm text-pol-text truncate">
              :{emoji.id}:
            </span>
          </button>
        ))}
      </div>
      <div className="px-3 py-1 border-t border-cream-dark/50">
        <span className="text-[10px] text-pol-text-secondary/50 font-sans">
          :{query}
        </span>
      </div>
    </div>
  );
}
